export const breakpoints = {
  mobile: "360px",
  tablet: "768px",
  desktop: "1440px",
};
